import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
// import { useDispatch } from "react-redux";
// import { AppDispatch } from "../../reduxStore/store";
// import { useAppSelector } from "../../reduxStore/hooks";
import {
  AlertColor,
  // CircularProgress,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  // Stack,
  styled,
} from "@mui/material";
import MedicalWisdomSnackbar from "../../components/MedicalWisdomSnackbar";
import { useForm } from "react-hook-form";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import mw from "../../assets/images/logo/mw.png";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  RESET_PASSWORD_TITLE,
  RESET_PASSWORD_SUB_TITLE,
} from "../../constants/staticText";
import { useSearchParams } from "react-router-dom";
// import { ResetPasswordBody } from "../../reduxStore/resetPassword/Model";
// import {
//   resetPassword,
//   updateResetPasswordClearRes,
// } from "../../reduxStore/resetPassword/resetPasswordSlice";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

interface ResetPasswordProps {
  open: boolean | undefined;
  toggleDrawer: (newOpen: boolean) => void;
}

interface IFormInput {
  password: string;
  confirm_password: string;
}

// yup schema
const schema = yup.object().shape({
  password: yup
    .string()
    .required("Password is a required field")
    .matches(
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?!.* ).{8,30}$/,
      "Password must contain one digit from 1 to 9, one lowercase letter, one uppercase letter, no space, and it must be 8-30 characters long"
    ),
  confirm_password: yup
    .string()
    .required("Confirm password is a required field")
    .matches(
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?!.* ).{8,30}$/,
      "Password must contain one digit from 1 to 9, one lowercase letter, one uppercase letter, no space, and it must be 8-30 characters long"
    )
    .oneOf([yup.ref("password")], "Confirm password must match with password")
    .test(
      "not-username",
      "Password must not contain the username",
      function (value) {
        return (
          !value ||
          !this.parent.username ||
          !value.includes(this.parent.username)
        );
      }
    ),
});
const CustomList = styled(List)({
  listStyleType: "none",
  padding: 0,
});
const CustomListItem = styled(ListItem)({
  display: "list-item",
  listStyleType: "none",
  padding: 0,
});

export default function ResetPassword({
  open,
  toggleDrawer,
}: ResetPasswordProps) {
  const [searchParams] = useSearchParams();
  // const code = searchParams.get("code");
  const username = searchParams.get("user");
  // const dispatch = useDispatch<AppDispatch>();
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [validations, setValidations] = React.useState({
    minLength: false,
    upperAndLowerCase: false,
    numberOrSymbol: false,
    notUsername: false,
  });
  const [resetPasswordMsgType] =
    React.useState<AlertColor>("success");
  const closeResetPasswordSnackbar = () => {
    // dispatch(updateResetPasswordClearRes());
    setResetPasswordMsg("");
  };
  const handleClickOpenMedicalWisdom = () => {
    //console.log("medicalWISDOM ARR Viewer");
  };

  const [resetPasswordMsg, setResetPasswordMsg] = React.useState("");
  // const resetPasswordDetails = useAppSelector((state) => state.resetPassword);
  const validatePassword = (inputPassword: string) => {
    setValidations({
      minLength: inputPassword.length >= 8,
      upperAndLowerCase: /^(?=.*[a-z])(?=.*[A-Z])/.test(inputPassword),
      numberOrSymbol: /\d|[^A-Za-z0-9]/.test(inputPassword),
      notUsername: !inputPassword.includes(username!),
    });
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newPassword = event.target.value;
    validatePassword(newPassword);
  };
  // React.useEffect(() => {
  //   if (resetPasswordDetails?.successMsg !== "") {
  //     setResetPasswordMsgType("success");
  //     setResetPasswordMsg(resetPasswordDetails?.successMsg);
  //     setTimeout(() => {
  //       dispatch(updateResetPasswordClearRes());
  //     }, 100);

  //     // Navigate to reset password success screen
  //     toggleDrawer(true);
  //   }
  //   if (resetPasswordDetails?.error !== "") {
  //     setResetPasswordMsg(resetPasswordDetails?.error);
  //     setResetPasswordMsgType("error");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [resetPasswordDetails]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInput>({ resolver: yupResolver(schema) });

  // login form submit
  const onSubmit = (data: IFormInput) => {
    // const resetPasswordBody = {
    //   username: username,
    //   otp: code,
    //   new_password: data.password,
    // } as ResetPasswordBody;

    // dispatch(resetPassword(resetPasswordBody));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "center",
        gap: 1,
      }}
    >
      <Box>
        <img
          src={mw}
          width="250"
          height="42"
          style={{
            objectFit: "cover",
            objectPosition: "left",
          }}
          alt="Medical Wisdom logo"
        />
      </Box>
      <Box sx={{ py: 2 }}>
        <Typography
          variant="h4"
          className="heading"
          sx={{ padding: 0, mb: 0, lineHeight: 1 }}
        >
          {RESET_PASSWORD_TITLE}
        </Typography>
        <Typography variant="subtitle1" sx={{ padding: 0, mb: 0 }}>
          {RESET_PASSWORD_SUB_TITLE}
        </Typography>
      </Box>

      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Box>
          <TextField
            type={showPassword ? "text" : "password"}
            required
            fullWidth
            variant="outlined"
            placeholder="Password"
            autoComplete="new-password"
            size="small"
            {...register("password")}
            error={Boolean(errors.password)}
            helperText={errors.password?.message}
            onChange={handleChange}
            sx={{ pb: 0 }}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlinedIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
          <CustomList sx={{my: 1}}>
            <CustomListItem
              style={{ color: validations.minLength ? "green" : "red" }}
            >
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
                spacing={1}
              >
                <Grid>
                  {validations.minLength === true ? (
                    <CheckIcon />
                  ) : (
                    <CloseIcon />
                  )}
                </Grid>
                <Grid>
                  <ListItemText primary="Contains at least 8 characters" />
                </Grid>
              </Grid>
            </CustomListItem>
            <CustomListItem
              style={{ color: validations.upperAndLowerCase ? "green" : "red" }}
            >
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
                spacing={1}
              >
                <Grid>
                  {validations.upperAndLowerCase === true ? (
                    <CheckIcon />
                  ) : (
                    <CloseIcon />
                  )}
                </Grid>
                <Grid>
                  <ListItemText primary="Contains both lower (a-z) and upper case letters" />
                </Grid>
              </Grid>
            </CustomListItem>
            <CustomListItem
              style={{ color: validations.numberOrSymbol ? "green" : "red" }}
            >
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
                spacing={1}
              >
                <Grid>
                  {validations.numberOrSymbol === true ? (
                    <CheckIcon />
                  ) : (
                    <CloseIcon />
                  )}
                </Grid>
                <Grid>
                  <ListItemText primary="Contains at least one number (0-9) or a symbol" />
                </Grid>
              </Grid>
            </CustomListItem>
            <CustomListItem
              style={{ color: validations.notUsername ? "green" : "red" }}
            >
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
                spacing={1}
              >
                <Grid>
                  {validations.notUsername === true ? (
                    <CheckIcon />
                  ) : (
                    <CloseIcon />
                  )}
                </Grid>
                <Grid>
                  <ListItemText primary="Does not contain your username" />
                </Grid>
              </Grid>
            </CustomListItem>
          </CustomList>
        </Box>
        <TextField
          type={showConfirmPassword ? "text" : "password"}
          required
          fullWidth
          variant="outlined"
          placeholder="Confirm Password"
          autoComplete="new-password"
          size="small"
          {...register("confirm_password")}
          error={Boolean(errors.confirm_password)}
          helperText={errors.confirm_password?.message}
          sx={{ pb: 2 }}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlinedIcon />
                </InputAdornment>
              ),
            },
          }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="medium"
          sx={{ my: 1 }}
          style={{ textTransform: "none" }}
          // onClick={toggleDrawer(true)}
        >
          {/* {resetPasswordDetails.loading === true ? (
            <Stack direction="row" spacing={1}>
              <Typography
                sx={{
                  textTransform: "none",
                }}
              >
                Save Password
              </Typography>
              <Box pl={1}>
                <CircularProgress color="inherit" size={18} />
              </Box>
            </Stack>
          ) : (
            "Save Password"
          )} */}
          Save Password
        </Button>
      </form>
      <Grid
        container
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
        spacing={1}
      >
        <Grid>
          <Typography>Powered by</Typography>
        </Grid>
        <Grid>
          <Link
            component="button"
            onClick={handleClickOpenMedicalWisdom}
            variant="body2"
            underline="hover"
            sx={{
              alignSelf: "baseline",
              fontWeight: "bold",
            }}
          >
            medicalWISDOM ARR Viewer
          </Link>
        </Grid>
      </Grid>
      <MedicalWisdomSnackbar
        msg={resetPasswordMsg}
        type={resetPasswordMsgType}
        alertClose={closeResetPasswordSnackbar}
      />
    </Box>
  );
}
